<template>
  <card v-if="pos.info">
    <template slot="header">
      <h4 class="card-title mb-0">{{ pos.info.na }}</h4>
      <p class="card-category">
        <b>{{ pos.info.sy }}</b> - {{ pos.info.isin }}
      </p>
    </template>
    <div class="row">
      <div class="col-md-4 ml-auto mr-auto"></div>
      <div class="col-md-8">
        <div class="chart-area">
          <line-chart
            style="height: 300px"
            :ref="'chart-' + pos.info.isin"
            :chart-data="weeklyChart.chartData"
            :gradient-stops="weeklyChart.gradientStops"
            :extra-options="weeklyChart.extraOptions"
          ></line-chart>
        </div>
      </div>
    </div>
  </card>
</template>
<script>
import { mapGetters } from "vuex";
import LineChart from "@/components/Charts/LineChart";
import * as chartConfigs from "@/components/Charts/config";
import config from "@/config";
import { getQuoteWeeklyHistory } from "../../dao/firestore";

export default {
  name: "position-detail",
  components: {
    LineChart
  },
  props: {
    position: {
      type: Object,
      description: "Current position object"
    }
  },
  computed: {
    ...mapGetters({
      livelist: "instruments/livelist",
      conf: "auth/conf"
    })
  },
  data() {
    return {
      pos: {},
      weeklyChart: {
        extraOptions: chartConfigs.purpleChartOptions,
        chartData: {
          datasets: [
            {
              label: "Data",
              fill: true,
              borderColor: config.colors.primary,
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: config.colors.primary,
              pointBorderColor: "rgba(255,255,255,0)",
              pointHoverBackgroundColor: config.colors.primary,
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 4,
              data: [0, 0, 0, 0, 0, 0]
            }
          ]
        },
        gradientColors: config.colors.primaryGradient,
        gradientStops: [1, 0.2, 0]
      }
    };
  },
  methods: {
    updatePosition() {
      const pos = this.$store.getters["instruments/addInfoToList"]([
        this.position
      ])[0];
      if (pos.info) {
        this.pos = pos;
        this.initChart();
      }
    },
    async initChart() {
      let quotes = await getQuoteWeeklyHistory(this.pos.info);
      quotes = quotes.slice(Math.max(quotes.length - 28, 0));

      this.weeklyChart.chartData.datasets[0].data = quotes.map(q => {
        return {
          x: q[0],
          y: q[4]
        };
      });
      this.$refs["chart-" + this.pos.info.isin].updateGradients(
        this.weeklyChart.chartData
      );
      this.$refs["chart-" + this.pos.info.isin].renderChart(
        this.weeklyChart.chartData,
        this.weeklyChart.extraOptions
      );
    }
  },
  mounted() {
    this.updatePosition();
  },
  watch: {
    livelist(newValue, oldValue) {
      this.updatePosition();
    },
    conf(newValue, oldValue) {
      this.updatePosition();
    }
  }
};
</script>
<style></style>
